/*
CUSTOMIZATIONS:
- aggiunto il titolo della sezione 'Ulteriori informazioni'
*/

import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages, useIntl } from 'react-intl';

import {
  Metadata,
  HelpBox,
  richTextHasContent,
} from 'design-comuni-plone-theme/components/ItaliaTheme/View';

const messages = defineMessages({
  ulteriori_informazioni: {
    id: 'ulteriori_informazioni',
    defaultMessage: 'Ulteriori informazioni',
  },
});

const BandoUlterioriInformazioni = ({ content }) => {
  const intl = useIntl();
  return (
    <>
      {/* ULTERIORI INFORMAZIONI */}
      <Metadata
        content={content}
        showSectionTitle={richTextHasContent(content?.riferimenti_bando)}
        title={intl.formatMessage(messages.ulteriori_informazioni)}
      >
        {richTextHasContent(content?.riferimenti_bando) && (
          <HelpBox text={content?.riferimenti_bando} />
        )}
      </Metadata>
    </>
  );
};

BandoUlterioriInformazioni.propTypes = {
  content: PropTypes.shape({
    riferimenti_bando: PropTypes.shape({
      data: PropTypes.string,
    }),
  }).isRequired,
};
export default BandoUlterioriInformazioni;
